// Doit rester le PREMIER import : intercepte les 401 de toutes les instances axios créées ensuite.
import './auth/installSessionExpiry';
import React from 'react';
import { createRoot } from 'react-dom/client'; // ✅ nouvelle API
import App from './App';
import { Provider } from 'react-redux';
import store from './store/';
import ErrorBoundary from './Error/ErrorBoundary';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from './store';
import AuthInitializer from "./utils/AuthInitializer";

const CLIENT_ID = "452985709921-es6sboe12e512i2dsuq40rah57164fed.apps.googleusercontent.com";

const container = document.getElementById('root');
const root = createRoot(container); // ✅ créer le root React 18

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ErrorBoundary>
                    <GoogleOAuthProvider clientId={CLIENT_ID}>
                        <AuthInitializer>
                           <App />
                        </AuthInitializer>
                    </GoogleOAuthProvider>
                </ErrorBoundary>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);
